'use strict';
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');

var BaseView = require('components-framework/view/base.view');

module.exports = BaseView.extend({
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#\{]([\s\S]+?)[^\}]\}\}/g, // eslint-disable-line no-useless-escape
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },

    selectors: {
        allFocused: 'input:not([type="hidden"]), select',
        freqPassBody: '.freq_pass_body',
        freqPassClearInput: '.clear_input',
        freqPassNotifSaved: '.freq_pass_notification_saved',
        freqPassNotifDelete: '.freq_pass_notification_delete',
        freqPassNotifError: '.freq_pass_notification_error',
        freqPassNotifFatalError: '.freq_pass_notification_fatalerror',
        freqPassEdit: '.freq_pass_edit',
        freqPassEditDelete: '.freq_pass_edit_delete',
        freqPassEditDeleteLink: '.freq_pass_edit_delete_link',
        freqPassEditDeleteHint: '.freq_pass_delete_hint',
        freqPassEditDeleteView: '.freq_pass_edit_delete_overlay',
        freqPassEditDeleteClose: '.freq_pass_edit_delete_close',
        freqPassEditDeleteBtn: '.freq_pass_edit_deleteBtn',
        freqPassEditDiscardView: '.freq_pass_edit_discard_overlay',
        freqPassEditDiscardLink: '.freq_pass_edit_discard_changes',
        freqPassEditDiscardClose: '.freq_pass_edit_discard_close',
        freqPassEditReturnBtn: '.freq_pass_edit_returnBtn',
        freqPassFormContactInfo: '.freq_pass_form_contact_info',
        freqPassList: '.freq_pass_list',
        freqPassMainPass: '.freq_pass_main_pass',
        freqPassNewBtn: '.freq_pass_newBtn',
        freqPassNew: '.freq_pass_new',
        freqPassReturn: '.freq_pass_return',
        templateBody: '.freq_pass_body_template',
        templateItem: '.freq_pass_items_template',
        overviewOverlay: '.overview_delete_passenger_overlay',
        overviewClose: '.overview_delete_passenger_close',
        overviewCloseNo: '.overview_delete_passenger_close_no',
        overviewDelete: '.overview_delete_passenger_yes',

    },

    events: {
        'tap .freq_pass_newBtn': 'goToTappedNewPassenger',
        'tap .freq_pass_edit': 'goToTappedPassenger',
        'tap .freq_pass_saveNewBtn': 'savePassenger',
        'tap .freq_pass_return': 'onTapFreqPassReturn',
        'tap .freq_pass_edit_deleteBtn': 'onTapFreqPassDelete',
        'tap .clear_input': 'onClearInput',
        'tap .freq_pass_edit_discard_changes': 'onOpenDiscardView',
        'tap .freq_pass_edit_discard_close': 'onCloseDiscardView',
        'tap .freq_pass_edit_delete_link': 'onOpenDeleteView',
        'tap .freq_pass_edit_delete_close': 'onCloseDeleteView',
        'tap .freq_pass_edit_returnBtn': 'onCloseDeleteView',
        'tap .freq_pass_delete_hint': 'onTapDeleteHint',
        'tap .overview_delete_passenger_close': 'onTapOverviewClose',
        'tap .overview_delete_passenger_close_no': 'onTapOverviewClose',
        'tap .overview_delete_passenger_yes': 'deletePassenger',
        'change .freq_pass_main_pass': 'onChangeMainPassenger',
        'focus input:not([type="hidden"]), select': '_focusHandler',
    },

    _focusHandler: function(evt) {
        const $el = $(evt.target);
        $el.closest('.input_wrapper').removeClass('valid').addClass('focused');
    },

    _tracktEvent: function(action, label, category) {
        // Analytics: event tracking
        trackingUtils.trackEventWithCategory(category, action, label);
    },

    trackTagCommanderPage: function() {
        tagManagement.updateDatalayer();
    },

    checkEmpty: function($input) {
        return !Odigeo._.isEmpty($input.val());
    },

    checkRequiredEmpty: function($input) {
        return $input.attr('required') === 'required' && !this.checkEmpty($input);
    },

    checkValidity: function($input) {
        const valData = $input.data();
        const value = $input.val();
        let validity = true;
        let pattern;
        switch ($input.data('validationType')) {
            case this.model.validationTypes.REGEX_VALIDATOR:
                if ($input.attr('required') === 'required' || value !== '') {
                    pattern = new RegExp(valData.pattern);
                    validity = pattern.test(value);
                }
                break;
            case this.model.validationTypes.NULL_VALIDATOR:
                validity = !!value;
                break;
            default:
                return true;
        }
        return validity;
    },

    isProfileElement: function(dataName) {
        return !Odigeo._.isUndefined(this.model.traveller.profile[dataName]) && dataName !== 'address';
    },

    isAddressElement: function(dataName) {
        return !Odigeo._.isUndefined(this.model.address[dataName]) && this.$el.find(this.selectors.freqPassMainPass).is(':checked');
    },

    createPassengerListeners: function() {
        const $dataNames = this.$el.find('[data-name]');

        Odigeo._.each($dataNames, function(input) {
            if (!Odigeo._.isEmpty($(input).val())) {
                $(input).closest('.input_wrapper').addClass('valid');
            }
        });

        $dataNames.on(Odigeo.Events.blur, Odigeo._.bind(function(evt) {
            const $targetedInput = $(evt.currentTarget);
            const $wrapper = $targetedInput.closest('.input_wrapper')
                .removeClass('invalid empty focused')
                .toggleClass('valid', !Odigeo._.isEmpty($targetedInput.val()));
            if ((this.isProfileElement($targetedInput.data('name')) || this.isAddressElement($targetedInput.data('name'))) &&
                (!this.checkValidity($targetedInput) || this.checkRequiredEmpty($targetedInput))) {
                $wrapper.addClass('empty').removeClass('valid');
            }
        }, this));

        this.model.bindPassengerDetail = true;
    },

    setTemplate: function() {
        if (null !== this.model.userDTO &&
            null !== this.model.userDTO.traveller &&
            (!this.model.initialized || Odigeo._.isEmpty(this.model.userID))) {
            this.$el.html(this.templates.main({keys: this.keys}));
            this.$el.find(this.selectors.freqPassBody).empty().append(this.templates.frequentPassengersItems({
                model: this.getExtendedData(this.model),
                keys: this.keys,
            }));
            this.model.initialized = true;
            const instantTransitionsOptions = {
                fadeInTimes: {
                    duration: 0,
                    delay: 0,
                },
                fadeOutTimes: {
                    duration: 0,
                    delay: 3,
                },
            };
            Odigeo.UIElements.fade.enhance(this.$el.find(this.selectors.freqPassNotifSaved), instantTransitionsOptions);
            Odigeo.UIElements.fade.enhance(this.$el.find(this.selectors.freqPassNotifDelete), instantTransitionsOptions);
            Odigeo.UIElements.fade.enhance(this.$el.find(this.selectors.freqPassNotifFatalError), instantTransitionsOptions);
        }
        this.$el.find(this.selectors.freqPassNew).addClass('hidden');
        this.$el.find(this.selectors.freqPassList).removeClass('hidden');
        this.$el.find(this.selectors.freqPassBody).removeClass('hidden');
        this.$el.find(this.selectors.freqPassEditDelete).addClass('hidden');
        this.$el.find(this.selectors.freqPassNotifError).addClass('hidden');
    },

    getExtendedData: function(data) {
        const extendedData = Odigeo._.extend(data, {
            countries: Odigeo.UserArea.countries,
            passengerRegexValidation: Odigeo.UserArea.passengerRegexValidation,
            addressRegexValidation: Odigeo.UserArea.addressRegexValidation,
        });
        return extendedData;
    },

    showPassengers: function() {
        this.trackTagCommanderPage();

        Odigeo.trigger(this.id + ':changePageTitle', 'main');

        if (!Odigeo._.isUndefined(this.model.actions[this.model.action])) {
            this.$el.find(this.selectors[this.model.actions[this.model.action]]).trigger('fadeElement');
        }

        this.model.action = '';
    },

    goToTappedNewPassenger: function(e) {
        e.preventDefault();
        Odigeo.Router.navigate('frequentpassengers', {params: 'new'});
    },

    goToTappedPassenger: function(e) {
        let index;
        e.preventDefault();
        index = $(e.currentTarget).data('index');

        Odigeo.Router.navigate('frequentpassengers', {params: index});
    },

    showEditor: function(isDefault, isNew) {
        const $mainPass = this.$el.find(this.selectors.freqPassMainPass);
        this.$el.find(this.selectors.freqPassList).addClass('hidden');

        this.$el.find(this.selectors.freqPassNew).removeClass('hidden');
        if (isNew) {
            this.$el.find(this.selectors.allFocused).find('option[selected]').prop('selected', true);
        }
        trackingUtils.trackEventWithCategory('my_area_pax', 'passenger_list', isNew ? 'add_new_passenger' : 'edit_passeger');

        Odigeo.trigger(this.id + ':changePageTitle', isNew ? 'new' : 'edit');
        $mainPass.prop('disabled', isDefault ? 'disabled' : false).prop('checked', isDefault ? true : false);

        Odigeo.UIElements.collapsive.enhance(this.$el.find(this.selectors.freqPassFormContactInfo), {initiallyExpanded: isDefault});

        this.$el.find(this.selectors.freqPassEditDelete).toggleClass('hidden', (isDefault || isNew));

        this.createPassengerListeners();
    },

    showEditorNew: function() {
        this.trackTagCommanderPage();

        const defaultCountry = (Odigeo.UserArea.countryId || '').toUpperCase();

        Odigeo._.each(this.$el.find('[data-name]'), function(item) {
            item.value = /^(country|prefixPhoneNumber)$/.test(item.getAttribute(('data-name'))) ? defaultCountry : '';
        });

        this.$el.find('#freq_pass_position').val('');

        this.showEditor(Odigeo._.isEmpty(this.model.userDTO.traveller), true);
    },

    showEditorModify: function(index) {
        this.trackTagCommanderPage();

        let passenger = this.model.userDTO.traveller[index];
        let attrName;
        const defaultCountry = (Odigeo.UserArea.countryId || '').toUpperCase();

        this.$el.find('#freq_pass_position').val(index);

        Odigeo._.each(this.$el.find('[data-name]'), function(item) {
            attrName = item.getAttribute('data-name');
            item.value = /^(country|prefixPhoneNumber)$/.test(attrName) ? defaultCountry : item.value;
            if (!Odigeo._.isEmpty(passenger.profile[attrName]) && attrName !== 'address') {
                item.value = passenger.profile[attrName];
            } else if (null !== passenger.profile.address && !Odigeo._.isEmpty(passenger.profile.address[attrName])) {
                item.value = passenger.profile.address[attrName];
            }
            $(item).removeClass('od-freq-pass-error');
        });

        if (!Odigeo._.isEmpty(passenger.profile.name)) {
            $('#travellerName').text(passenger.profile.name + (passenger.profile.firstLastName ? ' ' + passenger.profile.firstLastName : ''));
        }

        this.showEditor(passenger.profile.isDefault, false);
    },

    deletePassenger: function(e) {
        let index;
        let id;
        e.preventDefault();

        trackingUtils.trackEventWithCategory('my_area_pax', 'pax_details', 'delete_pax_yes');

        index = $(e.currentTarget).data('index');
        id = this.model.userDTO.traveller[index].id;
        this.model.action = 'delete';

        Odigeo.trigger(this.id + ':submitUserRequest', {
            action: 'deletePassenger',
            data: {id: id, saveAfterUpdate: true},
        }, true);
    },

    deletePassengerOnEdit: function() {
        const index = this.$el.find('#freq_pass_position').val();
        let id;

        trackingUtils.trackEventWithCategory('my_area_pax', 'pax_details', 'delete_pax_open');

        id = this.model.userDTO.traveller[index].id;
        if (this.model.action !== 'delete') {
            this.model.action = 'delete';
            Odigeo.trigger(this.id + ':submitUserRequest', {
                action: 'deletePassenger',
                data: {id: id, saveAfterUpdate: true},
            }, true);
        }
    },

    savePassenger: function() {
        const errors = this.fillErrors();
        const index = this.$el.find('#freq_pass_position').val();
        const traveller = !Odigeo._.isEmpty(index) ?
            this.model.userDTO.traveller[index] : JSON.parse(JSON.stringify(this.model.traveller));
        const isMainPassenger = this.$el.find(this.selectors.freqPassMainPass).is(':checked');

        this.$el.find(this.selectors.freqPassNotifError).find('ul').empty();
        if (!Odigeo._.isEmpty(errors)) {
            this.$el.find(this.selectors.freqPassNotifError).find('ul').append(errors);
            this.$el.find(this.selectors.freqPassNotifError).removeClass('hidden');
            trackingUtils.trackEventWithCategory('my_area_pax', 'pax_details', 'save_pax_FE_error');
            if (!Odigeo._.isEmpty(this.$el.find(this.selectors.freqPassEditDiscardLink))) {
                this.$el.find(this.selectors.freqPassEditDiscardLink).trigger('hideHint', false);
            }
            this.$el.find(this.selectors.freqPassEditDiscardView).removeClass('open opened');
        } else {
            this.$el.find(this.selectors.freqPassNotifError).addClass('hidden');
            this.fillTraveller(traveller);
            if (isMainPassenger) {
                this.uncheckMainTravellers();
            }
            traveller.profile.isDefault = isMainPassenger;
            trackingUtils.trackEventWithCategory('my_area_pax', 'pax_details', 'save_pax');
            if (this.model.action !== 'save') {
                this.model.action = 'save';
                Odigeo.trigger(this.id + ':submitUserRequest',
                    {action: 'savePassenger', data: {traveller: traveller, saveAfterUpdate: true}}, true);
            }
        }
    },

    fillErrors: function() {
        let errors = '';
        Odigeo._.each(this.$el.find('[data-name]'), Odigeo._.bind(function(item) {
            const $wrapper = $(item).closest('.input_wrapper');
            $wrapper.removeClass('invalid empty focused');
            if (!Odigeo._.isEmpty($(item).val())) {
                $wrapper.addClass('valid');
            }
            if ((!Odigeo._.isUndefined(this.model.traveller.profile[item.getAttribute('data-name')]) &&
                    item.getAttribute('data-name') !== 'address') ||
                (!Odigeo._.isUndefined(this.model.address[item.getAttribute('data-name')]) &&
                    this.$el.find(this.selectors.freqPassMainPass).is(':checked'))) {
                if (false === this.checkValidity($(item))) {
                    errors += '<li>' + item.getAttribute('data-error') + '</li>';
                    $wrapper.addClass('empty').removeClass('valid');
                } else if (!Odigeo._.isNull(item.getAttribute('required')) && !this.checkEmpty($(item))) {
                    errors += '<li>' + item.getAttribute('data-mandatory') + '</li>';
                    $wrapper.addClass('empty').removeClass('valid');
                }
            }
        }, this));
        return errors;
    },

    fillTraveller: function(traveller) {
        Odigeo._.each(this.$el.find('[data-name]'), function(item) {
            if (!Odigeo._.isUndefined(this.model.traveller.profile[item.getAttribute('data-name')]) &&
                item.getAttribute('data-name') !== 'address') {
                traveller.profile = (Odigeo._.isEmpty(traveller.profile)) ? this.model.traveller.profile : traveller.profile;
                traveller.profile[item.getAttribute('data-name')] = item.value;
                if (item.getAttribute('data-name') === 'title') {
                    traveller.profile['gender'] = item.value === 'MR' ? 'MALE' : 'FEMALE';
                }
            } else if (this.$el.find(this.selectors.freqPassMainPass).is(':checked') &&
                !Odigeo._.isUndefined(this.model.address[item.getAttribute('data-name')]) &&
                !Odigeo._.isEmpty(item.value)) {
                if (Odigeo._.isEmpty(traveller.profile.address)) {
                    traveller.profile.address = this.model.address;
                }
                traveller.profile.address[item.getAttribute('data-name')] = item.value;
            }
        }, this);
    },

    uncheckMainTravellers: function() {
        Odigeo._.each(this.model.userDTO.traveller, Odigeo._.bind(function(trav) {
            trav.profile.isDefault = false;
            Odigeo.trigger(this.id + ':submitUserRequest',
                {action: 'savePassenger', data: {traveller: trav, saveAfterUpdate: false}}, true);
        }, this));
    },

    loading: function() {
        const freqPassBody = this.$el.find(this.selectors.freqPassBody);
        freqPassBody.addClass('hidden');
        freqPassBody.find('.freq_pass_list').addClass('hidden');
        freqPassBody.find('.freq_pass_new').addClass('hidden');
        this.$el.find('.freq_pass_edit_delete').addClass('hidden');
    },

    onChangeMainPassenger: function(e) {
        this.$el.find(this.selectors.freqPassFormContactInfo).trigger($(e.currentTarget).is(':checked') ? 'expandPanel' : 'collapsePanel');
    },

    onTapFreqPassReturn: function() {
        this.$el.find(this.selectors.freqPassNotifError).addClass('hidden');
        trackingUtils.trackEventWithCategory('my_area_pax', 'pax_details', 'discard_changes');
        Odigeo.Router.navigate('frequentpassengers', {});
    },

    onTapFreqPassDelete: function(e) {
        e.stopPropagation();
        e.preventDefault();
        // this delay is because in iPhone-Safari when you do a long touch you are clicking in this element and in the inputs behind this
        Odigeo._.delay(Odigeo._.bind(function() {
            this.$el.find(this.selectors.freqPassEditDeleteView).removeClass('open opened');
            this.deletePassengerOnEdit();
        }, this), 300);
    },

    onClearInput: function(e) {
        const $wrapper = $(e.currentTarget).closest('.input_wrapper');
        const $input = $wrapper.find('input');
        e.stopPropagation();
        e.preventDefault();
        $input.val('');
        if (this.checkRequiredEmpty($input)) {
            $wrapper.addClass('empty').removeClass('valid');
        }
        $input.focus();
    },

    onOpenDiscardView: function() {
        this.$el.find(this.selectors.freqPassEditDiscardView).addClass('open opened');
    },

    onCloseDiscardView: function() {
        this.$el.find(this.selectors.freqPassEditDiscardView).removeClass('open opened');
    },

    onOpenDeleteView: function() {
        this.$el.find(this.selectors.freqPassEditDeleteView).addClass('open opened');
    },

    onCloseDeleteView: function() {
        this.$el.find(this.selectors.freqPassEditDeleteView).removeClass('open opened');
    },

    onTapDeleteHint: function(e) {
        const index = $(e.currentTarget).data('index');
        const overlay = $(this.$el.find('.overview_delete_passenger_overlay[data-index="' + index + '"]'));
        overlay.addClass('open opened');
    },

    onTapOverviewClose: function(e) {
        const index = $(e.currentTarget).data('index');
        const overlay = $(this.$el.find('.overview_delete_passenger_overlay[data-index="' + index + '"]'));
        overlay.removeClass('open opened');
    },
});
